import { isSSR } from './index';

export const getStyleProperty = (element: HTMLElement, property: string): string => {
    if (isSSR) {
        return '';
    }

    return window.getComputedStyle(element).getPropertyValue(property);
};
